export const checkNameValid = (value) => !!value

export const checkRequiredDataValid = (value, listData) => {
  return !(!value && !listData.length)
}

export const handleLocationData = (locationData) => {
  const cloneLocationData = structuredClone(locationData)
  cloneLocationData.shift()
  return cloneLocationData.map((item) => {
    return {
      label: item.label,
      value: item.value,
      isI18n: false,
    }
  })
}
